import { ResultFormat } from "components/Button/ResultFormatButton";
import { CitationTag } from "components/CitationTag/CitationTag";
import { BadgesLoading } from "components/Loading/BadgesLoading";
import { CITATION_WIDTH } from "./SearchResult/constants";

const PaperMetadataLoading = ({ isEvenIndex }: { isEvenIndex: boolean }) => {
  return (
    <div
      className="flex items-center gap-1.5 text-fg-muted animate-pulse max-w-[448px]"
      style={{ animationDelay: isEvenIndex ? "-1.25s" : "-.25s" }}
    >
      <div className="w-[12.5%] h-3 rounded-full bg-bg-subtle" />·
      <div className="w-[12.5%] h-3 rounded-full bg-bg-subtle" />·
      <div className="w-1/4 h-3 rounded-full bg-bg-subtle" />·
      <div className="w-1/2 h-3 rounded-full bg-bg-subtle" />
    </div>
  );
};

type SearchResultLoadingProps = {
  index?: number;
  resultFormat?: ResultFormat;
};

export const SearchResultLoading = ({
  index = 0,
  resultFormat = ResultFormat.COMPACT,
}: SearchResultLoadingProps) => {
  // Used to create a subtle pulsing wave effect using offset animation delays
  // The delay is implemented using style= instead of the .stagger-animation class to hand-tune the ripple effect for more fine-grained control.
  const isEvenIndex = index % 2 === 0;

  return (
    <div
      data-testid="search-result-loading"
      className="relative border-b pt-4 pb-1.5 w-full"
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center">
          {/* Citation size is 29px to match the largest citation tag size */}
          <CitationTag className={`mr-3 w-[${CITATION_WIDTH}px]`} />
          <div
            className="flex flex-col w-full animate-pulse my-1.5"
            style={{ animationDelay: isEvenIndex ? "0" : "-1s" }}
          >
            <div className="bg-bg-subtle h-3 w-[80%] rounded-xl" />
          </div>
        </div>
        <div className="flex items-center w-full h-[40px]">
          <div className="flex-1">
            <PaperMetadataLoading isEvenIndex={isEvenIndex} />
          </div>
        </div>
      </div>
    </div>
  );
};
